// extracted by mini-css-extract-plugin
module.exports = {"poll":"dhsg2BeJn-poll","label":"dhsg1fE43-label","question":"dhsg3DqoA-question","total":"dhsga-Rwh-total","result":"dhsg2saQP-result","other":"dhsg5SNR--other"};